import { api } from "./api";

/**
 * P1 SLICE 3: client for the real, read-only Behavioral LPE action-metrics
 * API (`GET /api/email-delivery/dashboard/behavioral-actions`), merged in
 * P1 IMPLEMENTATION SLICE 2 (PR #358).
 *
 * Same shared `api` axios instance every other real-backed War Room surface
 * already uses -- no second HTTP stack. Auth/tenant scoping are attached
 * automatically by that instance's own request interceptor.
 *
 * Accepts the SAME seven governed filters as
 * emailDeliveryLpeFunnelApi.js's getEmailDeliveryLpeFunnelSummary, with the
 * identical serialization/omission convention (period/custom dates, then
 * broadcastId/audienceId/campaignId/programId/environment/state, each
 * omitted when falsy/"all"). `environment` here means the SAME LPE-side
 * governed Broadcast environment `getEmailDeliveryLpeFunnelSummary` already
 * sends -- this client must NEVER send `observed_ghl_environment` (that
 * name is reserved exclusively for the EDT-side
 * emailDeliveryDashboardApi.js client).
 *
 * Response contains exactly the eight frozen Behavioral LPE action metrics
 * (online_enrollment_actions, continue_online_handoff_arrivals,
 * agent_assistance_referrals, agent_contact_actions, call_agent_actions,
 * schedule_agent_actions, save_quote_opens, save_quote_submissions), each
 * `{value, grain, attempts_with_action, journeys_with_action}` -- this
 * client does not reshape, rename, or derive anything from that response;
 * it is a verbatim pass-through of the backend's own contract.
 */
export async function getEmailDeliveryBehavioralActionsSummary({
  period = "mtd",
  startDate,
  endDate,
  broadcastId,
  audienceId,
  campaignId,
  programId,
  environment,
  state,
} = {}) {
  const params = { period };
  if (period === "custom") {
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
  }
  if (broadcastId) params.broadcast_id = broadcastId;
  if (audienceId) params.audience_id = audienceId;
  if (campaignId) params.campaign_id = campaignId;
  if (programId) params.program_id = programId;
  if (environment && environment !== "all") params.environment = environment;
  if (state) params.state = state;
  const res = await api.get("/email-delivery/dashboard/behavioral-actions", { params });
  return res.data;
}

export default getEmailDeliveryBehavioralActionsSummary;
